import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { takeEvery, takeLatest, put, delay } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { getUserItems as getUserItemsRequest, getFavouriteItems as getFavouriteItemsRequest, getUserBundleItems as getUserBundleItemsRequest, getSimilarItems as getSimilarItemsRequest, getCatalogItems as getCatalogItemsRequest, getRecommendedItems as getRecommendedItemsRequest } from 'data/api';
import { transformCurrencyAmountDto } from 'data/transformers/currency-amount';
import { scrollToTop } from 'libs/utils/window';
import { actions as filterActions } from 'state/catalog-filters/slice';
import { getSearchSessionId, getIsSearchSessionStale, getSelectedDynamicFilters, getFilters } from 'state/catalog-filters/selectors';
import { actions as closetPromotionActions } from 'state/closet-promotion/slice';
import { Screen } from 'constants/tracking/screens';
import * as statelessActions from './actions';
import { actions } from './slice';
import * as selectors from './selectors';
import { PER_PAGE, CATALOG_FETCH_ITEM_DEBOUNCE_AMOUNT } from './constants';
export function* getUserItems(_ref) {
  let {
    payload: {
      userId,
      filter
    }
  } = _ref;
  const currentPage = yield select(selectors.getUserItemCurrentPage);
  const response = yield* call(getUserItemsRequest, {
    userId,
    currentPage,
    perPage: PER_PAGE,
    filter
  });

  if ('errors' in response || !response.items && !response.drafts) {
    yield put(actions.getUserItemsFailure({
      errors: []
    }));
    return;
  }

  yield put(actions.getUserItemsSuccess(response));
}
export function* getUserBundleItems(_ref2) {
  let {
    payload: {
      userId,
      selectedItemId
    }
  } = _ref2;
  const currentPage = yield select(selectors.getUserBundleItemCurrentPage);
  const response = yield* call(getUserBundleItemsRequest, {
    userId,
    currentPage,
    selectedItemId,
    perPage: PER_PAGE
  });

  if ('errors' in response) {
    yield put(actions.getUserBundleItemsFailure({
      errors: []
    }));
    return;
  }

  yield put(actions.getUserBundleItemsSuccess({
    items: response.items,
    pagination: response.pagination,
    containsOfflineVerificationItem: response.contains_offline_verification_item,
    offlineVerificationFee: response.offline_verification_fee && transformCurrencyAmountDto(response.offline_verification_fee)
  }));
}
export function* getFavouriteItems(_ref3) {
  let {
    payload: {
      userId
    }
  } = _ref3;
  const currentPage = yield select(selectors.getFavouriteItemCurrentPage);
  const response = yield* call(getFavouriteItemsRequest, {
    page: currentPage + 1,
    perPage: PER_PAGE,
    userId,
    includeSold: true
  });

  if ('errors' in response) {
    yield put(actions.getFavouriteItemsFailure({
      errors: []
    }));
    return;
  }

  yield put(actions.getFavouriteItemsSuccess(response));
}
export function* getRecommendedItems(_ref4) {
  let {
    payload: {
      userId
    }
  } = _ref4;
  const currentPage = yield* select(selectors.getRecommendedItemCurrentPage);
  const nextPageToken = yield* select(selectors.getRecommendedItemNextPageToken);
  const response = yield* call(getRecommendedItemsRequest, {
    page: currentPage + 1,
    perPage: PER_PAGE,
    nextPageToken,
    userId
  });

  if ('errors' in response) {
    yield put(actions.getRecommendedItemsFailure({
      errors: []
    }));
    return;
  }

  yield put(actions.getRecommendedItemsSuccess(response));
}
export function* getSimilarItems(_ref5) {
  let {
    payload: {
      brandId,
      statusId,
      catalogId
    }
  } = _ref5;
  const response = yield* call(getSimilarItemsRequest, {
    brandId,
    statusId,
    catalogId
  });

  if ('errors' in response) {
    yield put(actions.getSimilarItemsFailure({
      errors: []
    }));
    return;
  }

  yield put(actions.getSimilarItemsSuccess({
    items: response.items
  }));
}
export function* getCatalogItems(_ref6) {
  let {
    payload: {
      filters,
      selectedDynamicFilters,
      pagination,
      searchSessionId
    },
    meta: {
      isPaginationEvent
    }
  } = _ref6;
  const response = yield* call(getCatalogItemsRequest, _objectSpread(_objectSpread(_objectSpread({}, filters), pagination), {}, {
    searchSessionId,
    selectedDynamicFilters
  }));

  if ('errors' in response) {
    yield put(actions.getCatalogItemsFailure({
      errors: response.errors
    }));
    return;
  }

  yield put(actions.getCatalogItemsSuccess({
    items: response.items,
    pagination: response.pagination,
    searchCorrelationId: response.search_tracking_params.search_correlation_id,
    searchSessionId: response.search_tracking_params.search_session_id,
    globalSearchSessionId: response.search_tracking_params.global_search_session_id
  }, {
    isPaginationEvent
  }));
}
export function* paginationChange() {
  yield call(scrollToTop);
}
export function* catalogParamsChange(_ref7) {
  let {
    isPaginationEvent
  } = _ref7;
  yield delay(CATALOG_FETCH_ITEM_DEBOUNCE_AMOUNT);

  if (!isPaginationEvent) {
    yield put(closetPromotionActions.clearSeenClosets());
  }

  const filters = yield* select(getFilters);
  const selectedDynamicFilters = yield* select(getSelectedDynamicFilters);
  const page = yield* select(selectors.getCatalogItemCurrentPage);
  const time = yield* select(selectors.getCatalogItemTime);
  const perPage = yield* select(selectors.getCatalogItemPerPage);
  const searchSessionId = yield* select(getSearchSessionId);
  const isSearchSessionStale = yield* select(getIsSearchSessionStale);
  yield put(actions.getCatalogItemsRequest({
    filters,
    selectedDynamicFilters,
    pagination: {
      page,
      perPage,
      time
    },
    searchSessionId: isSearchSessionStale ? undefined : searchSessionId
  }, {
    isPaginationEvent
  }));
}
export function* getClosetPromotions() {
  yield put(closetPromotionActions.getClosetPromotionsRequest({
    screenName: Screen.Catalog
  }));
}
export default function* saga() {
  yield takeEvery(actions.getUserItemsRequest, getUserItems);
  yield takeEvery(actions.getUserBundleItemsRequest, getUserBundleItems);
  yield takeEvery(actions.getFavouriteItemsRequest, getFavouriteItems);
  yield takeEvery(actions.getSimilarItemsRequest, getSimilarItems);
  yield takeEvery(actions.getRecommendedItemsRequest, getRecommendedItems);
  yield takeLatest(actions.getCatalogItemsRequest, getCatalogItems);
  yield takeEvery([actions.setCatalogItemsPage, actions.setCatalogItemsPerPage], paginationChange);
  yield takeLatest([filterActions.changeFilters, filterActions.applyPersonalizedSizesSuccess, statelessActions.retryCatalogItemsRequest], catalogParamsChange, {
    isPaginationEvent: false
  });
  yield takeLatest([actions.setCatalogItemsPage, actions.setCatalogItemsPerPage], catalogParamsChange, {
    isPaginationEvent: true
  });
  yield takeLatest(actions.getCatalogItemsSuccess, getClosetPromotions);
}